export const INITIAL_ROUTE = '/companies';
